export default __webpack_public_path__ + "static/media/chevronRight.15304538.svg";